import * as e from "react";
import s from "../lib/IconBase.es.js";
import a from "../defs/TestTube.es.js";
const o = e.forwardRef((t, r) => /* @__PURE__ */ e.createElement(s, { ref: r, ...t, weights: a }));
o.displayName = "TestTubeIcon";
const n = o;
export {
  n as TestTube,
  o as TestTubeIcon
};
